import { UrlApi } from "../../../services/apirest";
import {fetchPermisosPorModulo, fetchPermisos} from "../../../services/services";
import * as api from "./api"

export async function predeterminarLinea(dataCliente, dataDireccion, paramsNegocio, setRegPrecio, setItems) {
  // que pasa con la predeterminacion de la linea si no tengo direccion de entrega cargada, y elijo la fiscal ? que es algo qe puede pasar

  const { ruta_default_producto, ruta_precio_lista, ruta_precio_especial } = parseNegocioParams(paramsNegocio, dataCliente.id_negocio_cliente)
  const idProdDef = dataDireccion?.id_producto || await api.getProductoXIdDir(ruta_default_producto, dataDireccion.id);

  if (!idProdDef) console.log("No hay producto en domicilio de entrega, o no hay cargado producto predeterminado en envasado_producto_predeterminado")

  //horrible que este hardcodeado pero bueno hay que resolver
  const urlCompleta = {
    1: Boolean(dataCliente.precio_especial) ? `${UrlApi}${ruta_precio_especial}${dataCliente.id}` : `${UrlApi}${ruta_precio_lista}${dataCliente.id_empresa}/${dataCliente.id_sucursal}/${dataCliente.id_segmento}/${idProdDef}`,
    3: Boolean(dataCliente.precio_especial) ? `${UrlApi}${ruta_precio_especial}${idProdDef}/${dataCliente.id}/${dataCliente.id_sucursal}` : `${UrlApi}${ruta_precio_lista}${idProdDef}/${dataCliente.id_sucursal}`
  }

  const precios = await api.getPrecios(urlCompleta[dataCliente?.id_negocio_cliente]);

  if (!precios){
    const setDatosXDefecto = {
      1:{unidadMedida:dataCliente?.id_um_facturacion || 2, descUnidadMedida: dataCliente?.um_abreviatura?.toUpperCase(), idProducto:1},
      3:{unidadMedida:1, descUnidadMedida: "UN", idProducto:4}
    }
    setItems((prev)=>{
      const nuevo = [...prev] //copia de items
      nuevo[0]={
        cantidad:"",
        unidadMedida: setDatosXDefecto[dataCliente?.id_negocio_cliente]?.unidadMedida||null,
        descUnidadMedida: setDatosXDefecto[dataCliente?.id_negocio_cliente]?.descUnidadMedida||null,
        precioUnitario: 0,
        totalItem: "",
        idProducto: setDatosXDefecto[dataCliente?.id_negocio_cliente]?.idProducto||null,
        especial:0,
        stockeable:true
      }
      return nuevo;
    })
    return;
  } 

  setRegPrecio(precios)
  const defPrecio = precios[dataCliente.field_precio]
  setItems(prev => {
    const nuevo = [...prev]
    nuevo[0] = {
      cantidad: "",
      unidadMedida: dataCliente?.id_um_facturacion || null,
      descUnidadMedida: dataCliente?.um_abreviatura?.toUpperCase() || null, //aca va la descripcion de la unidad de medida
      precioUnitario: defPrecio || "",
      totalItem: "",
      idProducto: idProdDef || null,
      especial: dataCliente.precio_especial,
      stockeable:true
    }
    return nuevo;
  })
}

export const parseNegocioParams = (params, idNegocioCliente) => {
  return JSON.parse(params.find((param) => param.idtipocliente === idNegocioCliente)?.params);
}

export const validaUMProducto = (productos, idProductoLinea, IdUMLinea) => {
  const umValidas = productos.find((producto)=>producto.idproducto === idProductoLinea).um.split(",");

  const esValido = umValidas.some((umValidas)=>umValidas == IdUMLinea); 

  return esValido;
}

export const definePrecioUnitario = (regPrecio, ums, idProductoLinea, idUMLinea)=> {
  if(!regPrecio || !idProductoLinea || !idUMLinea) return 0;

  const keyPrecio = ums.find((um)=>um.id == idUMLinea)?.campo;
  
  if(!keyPrecio) return 0;

  let precio = 0;

  if(regPrecio.id_producto === idProductoLinea) precio = regPrecio[keyPrecio];
  
  return precio;
}

export const setDatosPorDefecto = async (
  idSucUser, 
  setFormData, 
  setEmpresas, 
  setSucursales, 
  // setSucTieneAlias,
  setUserSucData
) => {
  const dataSucUsu = await api.getDataSucUsuario(idSucUser);
  setUserSucData(dataSucUsu);
  // console.log("datos de la sucursal del usuario: ", dataSucUsu)

  //primero tengo q obtener esto para rellenar las opciones y luego predeterminarlas. si no los txtfld quedan vacios.
  // const empresas = await api.getEmpresasFacturadoras(); 
  const empresas = await api.getEmpresasPorNegocio(); 
  setEmpresas(empresas)

  const defEmpresa = parseInt(dataSucUsu.factura_para.split(",")[0]); 
  const sucursales = await api.getSucursalesEmpresa(defEmpresa);
  setSucursales(sucursales)

  // setSucTieneAlias(!!dataSucUsu.id_alias);

  setFormData((prev) => {
    return {
      ...prev,
      empEmisora: defEmpresa,
      sucEmisora:idSucUser,
      aUsuario: 0, //se factura a CLIENTE USUARIO, si se desconoce el cliente real. la factura quedará en la cuenta corriente de usuario X. 
      aConsFinal: 0//se factura a CONSUMIDOR FINAL, si SE CONOCE el cliente, pero no se desea informarlo a ARCA. la factura quedará en la cuenta corriente del cliente real. 
    }
  });
}

export const definirPermisos = async (setPermisos) => {
  const permisosUsuario = await fetchPermisos("ventas_facturacion"); //no lo pongo en api porque ya esta hecha la funcion en services
  const permisosModulo = permisosUsuario.filter(permiso=>permiso.modulo === "ventas_facturacion" || permiso.modulo === "clientes_impuestos")

  const permisosResumidos = permisosModulo.reduce((acc, permiso) => {
    acc[permiso.funcion] = true;
    return acc;
  }, {});

  setPermisos(permisosResumidos)
}

export const getUserBranchesFilter = () => {
  const allAccess= Boolean(Number(localStorage.getItem("controlador"))) || localStorage.getItem("role") === "admin" || localStorage.getItem("role") === "superusuario";
  if (allAccess) {
    return localStorage.getItem("suc_auth");
  } else {
    return localStorage.getItem("sucursal");
  }
}

